import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Checkbox } from '@els/els-react--checkbox';

import './CheckboxFilter.custom.scss';

export default function CheckboxFilter(props) {
  const { filter, onChange } = props;
  const title = filter.get('title');
  const selected = filter.get('selected');

  return <Checkbox className="checkbox-filter" checked={selected} onChange={onChange} label={title} />;
}

CheckboxFilter.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};
